import { BrowserStorageKey } from "../../../../../hooks/useBrowserStorage";

export type ThreadResourcesDevConfig = {
  placement: "left" | "right";
};

export const THREAD_RESOURCES_DEV_CONFIG_STORAGE_KEY: BrowserStorageKey<ThreadResourcesDevConfig> =
  {
    keyName: "thread_resources_dev_config",
    default: { placement: "right" },
  };
